export type TaskIconCategory = {
    name        : string
    itemIcons   : string[]
}



export const TASK_ICON_CATEGORIES: TaskIconCategory[] = [
    {
        name : "Popular",
        itemIcons :  [
            'task',
            'idea',
            'question',
            'bug',

            'beer',
            'book',
            'briefcase',
            'social_broadcast',

            'upload',
            'download',


            'device_mobile',
            'device_desktop',

            'phone',
            'money',

            'device_video',
            'device_camera',
            'database',
            'file_binary',
            'file_code',
            'file_contact',
            'file_text',
            'flame',
            'globe',
            'gift',
            'dev_gist',
            'graph',
            'law',
            'key',
            'link',
            'location',
            'mail',
            'mail_read',
            'mention',
            'milestone',
            'study',
            'pulse',
            'social_rss',
            'search',
            'squirrel',
            'steps',
            'telescope',
            'tools',
            'contact',
            'anchor',
            'bookmark',
            'burst',
            'first_aid',
            'paint_bucket',
            'quote',
            'social_youtube',
            'trophy',
            'shield',
            'shopping_cart',
            'rocket',
            'brush',
            'bucket',
            'social_twitter',
            'userSearch',
            'megaphone',
        ]
    },

    {
        name        : 'Project Management',
        itemIcons   : [
            'folder',
            'project',
            'dev',
            'sprint',
            'backlog',
            'requests',
            'group',
            'section',
            'tag',
            'workspace',
            'briefcase',
            'view-projects-list',
            'view-portfolio',
        ]
    },
    {
        name        : 'Views',
        itemIcons   : [
            'view',
            'view-list',
            'view-table',
            'view-board',
            'view-calendar',
            'view-events-summary',
            'event',
            'view-expenses',
            'scrum',
            'view-gantt',
            'view-workload',
            'view-activity',
            'view-what-is-done',
            'view-pastdue',
            'view-priorities',
            'view-action-required',
            'view-tasks-by-user',
            'view-dashboard',
            'report',
            'user',
            'users',
            'request-form'
        ]
    },
    {
        name        : 'Development & Technology',
        itemIcons   : [
            'mobile',
            'desktop',
            'globe',
            'cloud',
            'upload',
            'download',
            'server',
            'database',
            'key',
            'api',
            'qa',
            'bug',
            'idea',
            'rocket',
            'microchip',
            'embed',
            'lightning',
            'network',
            'graph',
        ]
    },
    {
        name        : 'Collaboration & Communication',
        itemIcons   : [
            'support',
            'megaphone',
            'contact',
            'leads',
            'mail_black',
            'mail_read',
            'userSearch',
            'social_broadcast',
            'target',
            'aim',
            'mention',
            'quote',
            'social_rss',
            'search',
            'resources',
            'request',
            'request2',
            'link',
            'user-card', 'offices'
        ]
    },
    {
        name        : 'Documentation',
        itemIcons   : [
            'files',
            'page',
            'file_contact',
            'file_code',
            'file_audio',
            'file_binary',
            'file_media',
            'file_video',
            'file_archive',
            'file_text',
            'spreadsheet',
            'img',
        ]
    },
    {
        name        : 'Financials & e-commerce',
        itemIcons   : [
            'money',
            'credit_card',
            'inventory',
            'shopping_cart',
            'suitcase',
        ]
    },
    {
        name        : 'Education',
        itemIcons   : [
            'bookmark',
            'book',
            'wiki',
            'education',
            'graduate',
        ]
    },
    {
        name        : 'Creativity & Design',
        itemIcons   : [
            'pencil',
            'paint',
            'paint_roller',
            'brush',
        ]
    },
    {
        name        : 'Brands',
        itemIcons   : [
            'windows',
            'android',
            'apple',
            'figma',
            'googleCalendar',
            'googleDoc',
            'googleMap',
            'googleSheet',
            'googleSlides',
            'twitterX',
            'twitter',
            'facebook',
            'youtube',
            'brand',
        ]
    },
    {
        name        : 'Entertainment & Media',
        itemIcons   : [
            'chess',
            'game_console',
            'music',
            'speaker',
            'microphone',
            'football_ball',
            'flask',
            'beer',
            'birthday_cake',
            'hotel',
            'first_aid',
            'flame',
            'tshirt',
            'wheelchair',
            'flag',
            'squirrel',
            'tools',
            'telescope',
            'home',
            'milestone',
            'geo',
            'watch',
            'law',
            'feather',
            'magic_wand',
            'projection_screen',
            'smile',
            'smile_sad',
            'zzz',
            'burst',
            'life_ring',
            'tachometer',
            'anchor',
            'trophy',
        ]
    },
];


// export const TaskIconOptionsNew : string[][]  = [
//
//     [
//         'workspace',
//         'tasks',
//         'task',
//         'idea',
//         'question',
//         'bug',
//         'project',
//         'page',
//         'dev',
//         'sprint',
//         'backlog',
//         'someday_3',
//         'tag',
//         'kanban',
//         'scrum',
//         'report',
//         'goals',
//         'meetings',
//         'discussions',
//         'board',
//         'view',
//         'view-list',
//         'view-table',
//         'view-board',
//         'view-calendar',
//         'view-events-summary',
//         'view-gantt',
//         'view-workload',
//         'view-activity',
//         'view-what-is-done',
//         'view-pastdue',
//         'view-priorities',
//         'view-action-required',
//         'view-tasks-by-user',
//         'view-portfolio',
//         'view-projects-list',
//         'view-dashboard',
//         'group',
//         'section',
//         'wiki',
//         'information',
//         'brand',
//         'taskList',
//         'aim',
//     ],
//
//     [
//         'social_broadcast',
//         'phone',
//         'mail',
//         'mail_read',
//         'mention',
//         'social_rss',
//         'social_youtube',
//         'social_twitter',
//         'megaphone',
//         'requests',
//         'request',
//         'request2',
//         'twitter',
//         'facebook',
//         'youtube',
//         'mail_black',
//     ],
//
//     [
//         'upload',
//         'download',
//         'database',
//         'file_binary',
//         'file_code',
//         'file_contact',
//         'file_text',
//         'file_audio',
//         'file_media',
//         'file_video',
//         'file_archive',
//         'spreadsheet',
//         'files',
//         'folder',
//         'open_folder',
//         'img',
//         'image',
//         'link',
//         'embed',
//     ],
//
//     [
//         'device_mobile',
//         'device_desktop',
//         'device_video',
//         'device_camera',
//         'telescope',
//         'server',
//         'microchip',
//         'network',
//         'api',
//         'mobile',
//         'desktop',
//         'projection_screen',
//         'android',
//         'social_android',
//         'apple',
//         'social_apple',
//         'windows',
//         'social_windows',
//         'watch',
//         'game_console',
//     ],
//     [
//         'money',
//         'briefcase',
//         'law',
//         'credit_card',
//         'suitcase',
//         'expenses',
//         'view-expenses',
//         'leads',
//         'inventory',
//         'shopping_cart',
//         'user-card',
//         'offices',
//     ],
//     [
//         'tools',
//         'anchor',
//         'brush',
//         'bucket',
//         'paint',
//         'paint_bucket',
//         'paint_roller',
//         'magic_wand',
//         'flame',
//         'key',
//         'pencil',
//         'feather',
//         'flask',
//         'first_aid',
//         'burst',
//         'quote',
//     ],
//     [
//         'beer',
//         'book',
//         'globe',
//         'gift',
//         'contact',
//         'bookmark',
//         'squirrel',
//         'steps',
//         'study',
//         'study', // duplicate, but kept as per original request, though it will be removed by set
//         'tshirt',
//         'wheelchair',
//         'birthday_cake',
//         'hotel',
//         'flag',
//         'geo',
//         'smile',
//         'smile_sad',
//         'zzz',
//         'life_ring',
//         'calendar',
//         'home',
//         'event',
//         'education',
//         'graduation',
//         'graduation_cap',
//     ],
//     ['graph', 'pulse', 'tachometer', 'lightning', 'target'],
//     ['support', 'qa', 'resources'],
//     [
//         'figma',
//         'googleCalendar',
//         'googleDoc',
//         'googleMap',
//         'googleSheet',
//         'googleSlides',
//     ],
//     ['chess', 'music', 'speaker', 'microphone', 'football_ball']
// ]


export const TaskIconOptions  = [


    [
        'task',
        'idea',
        'question',
        'bug',

        'beer',
        'book',
        'briefcase',
        'social_broadcast',

        'upload',
        'download',


        'device_mobile',
        'device_desktop',

        'phone',
        'money',

        'device_video',
        'device_camera',
        'database',
        'file_binary',
        'file_code',
        'file_contact',
        'file_text',
        'flame',
        'globe',
        'gift',
        'dev_gist',
        'graph',
        'law',
        'key',
        'link',
        'location',
        'mail',
        'mail_read',
        'mention',
        'milestone',
        'study',
        'pulse',
        'social_rss',
        'search',
        'squirrel',
        'steps',
        'telescope',
        'tools',
        'contact',
        'anchor',
        'bookmark',
        'burst',
        'first_aid',
        'paint_bucket',
        'quote',
        'social_youtube',
        'trophy',
        'shield',
        'shopping_cart',
        'rocket',
        'brush',
        'bucket',
        'social_twitter',
        'userSearch',
        'megaphone',
    ]

];
